import { render, staticRenderFns } from "./LivePackages.vue?vue&type=template&id=6880ba64&"
import script from "./LivePackages.vue?vue&type=script&lang=js&"
export * from "./LivePackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports